import { AbstractControl } from '@angular/forms';

export function UploadExpenseReportDocument(
  control: AbstractControl
): { invalidFileType: boolean } | null {
  let allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.jfif', '.pdf'];

  allowedExtensions = allowedExtensions.map((extension) => control.value?.toLowerCase().endsWith(extension).toString());
  if (control.value && allowedExtensions.indexOf('true') === -1) {
    return { invalidFileType: true };
  }
  return null;
}
